<nav class="top-navbar">
    <div class="sidebar-toggler" (click)="sideNavigationService.toggleSidebar()">
        <div
            class="add-arrow"
            [ngClass]="{
                'add-arrow-left': sideNavigationService.isLeftMenuOpen,
                'add-arrow-right': !sideNavigationService.isLeftMenuOpen,
            }"></div>
    </div>

    <div class="d-flex flex-column justify-content-center">
        <div class="title">{{ title | translate }}</div>

        <app-breadcrumb></app-breadcrumb>
    </div>

    @if (communityUser) {
        <div class="menu-wrapper">
            <sb-settings-menu
                [user]="communityUser"
                [customerSettings]="commonDataForSettingsService.customerSettings"
                [communityName]="commonDataForSettingsService.communityName"
                [language]="commonDataForSettingsService.language"
                (logout)="authenticationService.logOff()">
            </sb-settings-menu>
        </div>
    }
</nav>
